import React from 'react';
import {Link} from 'react-router-dom';

function WorkExerpt({workObj}) {

    return (

        <article className="work-list">
            <h3 className="work-type">{workObj.type}</h3>
            <Link to={workObj.url}>
                <img src={workObj.thumbnail} alt={workObj.title +" Mockup"} className="thumbnail" />
            </Link>

            <div className="work-info">
                <Link to={workObj.url}><h2 className="work-title">{workObj.title}</h2></Link>
                <p className="work-exerpt">{workObj.exerpt}</p>    

                <Link to={workObj.url} className="btn">Learn More</Link>
            </div>
            

        </article>
    )
}

export default WorkExerpt
